/* Gift voucher box — session "Gift Vouchers", 15 Oct 2026. See snippets/bl-voucher-box.liquid.
   Talks only to /apps/voucher/* (worker bl-vouchers). Never touches the Breeze button. */
(function () {
  if (window.__blv) return;
  window.__blv = true;
  var KEY = "blv_applied";
  var SHAPE = /^CV-[A-Z0-9]{10}$/;          // L&M vouchers: "CV-" + 10 letters/digits = 13 characters
  var NOT_VALID = "Gift voucher not valid";
  var inr = function (n) { return "₹" + Math.round(Number(n) || 0).toLocaleString("en-IN"); };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };
  function store(v) { try { v ? sessionStorage.setItem(KEY, JSON.stringify(v)) : sessionStorage.removeItem(KEY); } catch (_) {} }
  function stored() { try { return JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch (_) { return null; } }
  // this browser's own id: Shopify can give the cart a new token after a checkout visit, so the worker also
  // recognises "the same customer re-applying" by this (found 15 Oct)
  var CLIENT = (function () {
    try { var c = localStorage.getItem("blv_client"); if (!c) { c = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("blv_client", c); } return c; } catch (_) { return ""; }
  })();
  function cartJs() { return fetch("/cart.js", { cache: "no-store", credentials: "same-origin" }).then(function (r) { return r.json(); }); }
  // the cart token carries a "?key=…" part that can differ between /cart.js calls (found 15 Oct): compare the id only
  function tok(t) { return String(t || "").split("?")[0]; }
  function sig(cart) { return (cart.items || []).map(function (i) { return i.variant_id + "x" + i.quantity; }).sort().join(","); }
  function rootOf(box) { return box.closest("#blCartDrawerRoot") || document.getElementById("blCartDrawerRoot"); }

  function render(box, st) {
    var body = box.querySelector("[data-blv-body]"), head = box.querySelector("[data-blv-toggle]");
    var open = st.mode !== "closed";
    head.setAttribute("aria-expanded", String(open));
    head.querySelector(".blv__chev").textContent = open ? "−" : "+";
    body.hidden = !open;
    var root = rootOf(box);
    if (root) root.classList.toggle("blv-on", st.mode === "applied");
    if (st.mode === "applied") {
      var a = st.applied;
      body.innerHTML =
        '<div class="blv__applied"><div><b>' + inr(a.amount) + ' voucher applied ✓</b><small>' + esc(a.code) + '</small></div>' +
        '<button type="button" class="blv__remove" data-blv-remove>Remove</button></div>' +
        (a.unused > 0 ? '<div class="blv__warn">This voucher can be used only once. ' + inr(a.unused) + ' of it will go unused. Add more items to use the full ' + inr(a.face) + '.</div>' : "") +
        '<div class="blv__tot"><div class="blv__line"><span>Items</span><span>' + inr(a.bill) + '</span></div>' +
        '<div class="blv__line blv__line--v"><span>Gift voucher</span><span>− ' + inr(a.amount) + '</span></div>' +
        '<div class="blv__line blv__line--big"><span>To pay</span><span>' + inr(a.pay) + '</span></div></div>' +
        // A real link, labelled "Checkout": counted by bl-path.js as the started-checkout step (Clarity, 15 Oct).
        '<a class="blv__go" href="' + esc(a.checkoutUrl) + '" data-blv-go>' + (a.pay > 0 ? "Pay balance " + inr(a.pay) + " · Checkout" : "Continue with voucher · Checkout") + '<span aria-hidden="true">→</span></a>' +
        '<div class="blv__under">' + (a.pay > 0 ? "Card or UPI · no Cash on Delivery" : "Nothing to pay · just your delivery address") + '</div>' +
        // found in the 15 Oct test: removing the gift card at checkout can't be undone there (the voucher number isn't a Shopify code)
        '<div class="blv__under">At checkout your voucher shows as a gift card. Please don’t remove it.</div>';
      return;
    }
    var val = st.code || "";
    var cls = st.mode === "bad" ? "is-bad" : st.mode === "busy" ? "is-busy" : "";
    body.innerHTML =
      '<div class="blv__row"><input class="blv__input ' + cls + '" data-blv-input placeholder="Enter voucher code" value="' + esc(val) + '" autocomplete="off" autocapitalize="characters" aria-label="Voucher code">' +
      '<button type="button" class="blv__apply" data-blv-apply' + (val && st.mode !== "working" ? "" : " disabled") + '>' + (st.mode === "working" ? "Checking…" : "Apply") + '</button></div>' +
      (st.mode === "bad" ? '<div class="blv__msg blv__msg--bad">' + esc(st.msg) + '</div>' :
       st.mode === "busy" ? '<div class="blv__msg blv__msg--busy">' + esc(st.msg) + '</div>' :
       '<div class="blv__hint">One voucher per order. Can’t be combined with Cash on Delivery.</div>');
  }

  function apply(box, st, code, quiet) {
    // never two applies at once: each apply switches off the previous gift card (found 15 Oct)
    if (st.inflight) return st.inflight;
    st.mode = "working"; st.code = code; if (!quiet) render(box, st);
    st.inflight = cartJs().then(function (cart) {
      var codes = (cart.cart_level_discount_applications || []).filter(function (d) { return d.type === "discount_code"; }).map(function (d) { return d.title; });
      return fetch("/apps/voucher/apply", {
        method: "POST", headers: { "content-type": "application/json" }, credentials: "same-origin",
        body: JSON.stringify({ code: code, client: CLIENT, cart: { token: cart.token, items: cart.items, attributes: cart.attributes, discount_codes: codes } }),
      }).then(function (r) { return r.json(); }).then(function (j) {
        if (j && j.ok) {
          st.mode = "applied"; st.applied = { code: code, cartToken: cart.token, sig: sig(cart), checkoutUrl: j.checkoutUrl, amount: j.amount, face: j.face, bill: j.bill, pay: j.pay, unused: j.unused, at: Date.now() };
          store(st.applied);
        } else {
          st.mode = j && j.reason === "HELD" ? "busy" : "bad";
          st.msg = (j && j.message) || "We couldn’t check the voucher just now. Please try again.";
          st.applied = null; store(null);
        }
        render(box, st);
      });
    }).catch(function () { st.mode = "bad"; st.msg = "We couldn’t check the voucher just now. Please try again."; render(box, st); })
      .then(function () { st.inflight = null; });
    return st.inflight;
  }

  function init(box) {
    if (box.__blv) return; box.__blv = true;
    box.hidden = false;
    var st = { mode: "closed", code: "", msg: "", applied: null };
    var saved = stored();
    // a saved voucher is shown again only for the same cart and inside its 30-minute hold
    cartJs().then(function (cart) {
      // same bag (items + sizes) inside the 30-minute hold → show it applied again, even if the cart token changed
      if (saved && saved.sig === sig(cart) && Date.now() - saved.at < 28 * 60000 && cart.item_count > 0) {
        st.mode = "applied"; st.applied = saved; st.code = saved.code;
        // new cart token → fetch a fresh checkout link (the worker recognises this browser and swaps the hold)
        if (tok(saved.cartToken) !== tok(cart.token)) { apply(box, st, saved.code, false); return; }
      }
      else store(null);
      render(box, st);
    }).catch(function () { render(box, st); });

    box.addEventListener("click", function (e) {
      // the green button always fetches a FRESH checkout link with the gift card on it: a remembered link can
      // point at a checkout where the card was removed (found in the 15 Oct test)
      var go = e.target.closest("[data-blv-go]");
      if (go && st.mode === "applied") {
        e.preventDefault();
        if (go.dataset.busy) return;
        go.dataset.busy = "1"; go.style.opacity = ".7";
        apply(box, st, st.applied.code, true).then(function () {
          if (st.mode === "applied" && st.applied && st.applied.checkoutUrl) location.href = st.applied.checkoutUrl;
        });
        return;
      }
      if (e.target.closest("[data-blv-toggle]")) { if (st.mode === "applied") return; st.mode = st.mode === "closed" ? "open" : "closed"; render(box, st); var i = box.querySelector("[data-blv-input]"); if (i && st.mode === "open") i.focus(); return; }
      if (e.target.closest("[data-blv-apply]")) {
        var v = (box.querySelector("[data-blv-input]").value || "").trim().toUpperCase().replace(/\s+/g, "");
        if (!v) return;
        // his rule 15 Oct: check the shape here, no server call, and never say what a valid code looks like
        if (!SHAPE.test(v)) { st.mode = "bad"; st.code = v; st.msg = NOT_VALID; render(box, st); return; }
        apply(box, st, v); return;
      }
      if (e.target.closest("[data-blv-remove]")) {
        var a = st.applied; st.mode = "open"; st.applied = null; store(null); render(box, st);
        if (a) fetch("/apps/voucher/remove", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ code: a.code, cart_token: a.cartToken, client: CLIENT }) }).catch(function () {});
      }
    });
    box.addEventListener("input", function (e) {
      if (!e.target.matches("[data-blv-input]")) return;
      st.code = e.target.value; if (st.mode !== "open") { st.mode = "open"; e.target.className = "blv__input"; var m = box.querySelector(".blv__msg"); if (m) m.remove(); }
      box.querySelector("[data-blv-apply]").disabled = !st.code.trim();
    });
    box.addEventListener("keydown", function (e) { if (e.key === "Enter" && e.target.matches("[data-blv-input]")) { e.preventDefault(); var b = box.querySelector("[data-blv-apply]"); if (!b.disabled) b.click(); } });

    // the bag changed while a voucher is applied → re-price it quietly (same cart = fresh 30-minute hold)
    var items = (rootOf(box) || document).querySelector(".bl-cartdrawer__items"), t = null;
    if (items && window.MutationObserver) new MutationObserver(function () {
      if (st.mode !== "applied") return;
      clearTimeout(t); t = setTimeout(function () {
        cartJs().then(function (cart) {
          if (!cart.item_count) { var a = st.applied; st.mode = "closed"; st.applied = null; store(null); render(box, st); if (a) fetch("/apps/voucher/remove", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ code: a.code, cart_token: a.cartToken, client: CLIENT }) }).catch(function () {}); return; }
          // re-apply only when the items or sizes really changed (not on every redraw of the cart)
          if (sig(cart) !== st.applied.sig) apply(box, st, st.applied.code, false);
        });
      }, 700);
    }).observe(items, { childList: true, subtree: true });
  }

  function boot() { document.querySelectorAll("[data-blv]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
